import React from "react";
import OrderPickupHistory from "../../admin/ReadyForPickup/OrderPickupHistory";
import usePageName from "../../../hocs/usePageName";
import { Container } from "@mui/material";

const OrderPickupHistoryPage = () => {
  usePageName({
    heading: "Pickup History",
    caption: null,
  });
  return (
    <Container>
      <OrderPickupHistory />
    </Container>
  );
};

export default OrderPickupHistoryPage;
